import { inject, Injectable } from '@angular/core';
import { SchemaEndpoints } from '@apis/cas';
import { DataPackage, DataPackageService, Schema } from '@apis/cas/generated';
import { environment } from '@environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CasDataService {
  #dataPackage: DataPackage | undefined;
  #schema: Schema | undefined;
  #dataPackageService = inject(DataPackageService);
  #schemaEndpoints = inject(SchemaEndpoints);

  async getSchema(): Promise<Schema> {
    if (this.#schema) return this.#schema;
    const schema = await firstValueFrom(this.#schemaEndpoints.getSchema());
    this.#schema = schema;
    return schema;
  }

  async getDataPackage(): Promise<DataPackage> {
    if (this.#dataPackage) {
      return this.#dataPackage;
    }
    const dataPackage = await firstValueFrom(
      this.#dataPackageService.getDataPackage(environment.defaultGame, environment.dataPackage, undefined, undefined, {
        httpHeaderAccept: 'application/json' as '*/*',
      }),
    );
    this.#dataPackage = dataPackage;
    return dataPackage;
  }

  async getDataPackageVersion(): Promise<string> {
    if (this.#dataPackage) return this.#dataPackage.versionUid;
    return await firstValueFrom(
      this.#dataPackageService.getDataPackageVersion(environment.defaultGame, environment.dataPackage, undefined, undefined, {
        httpHeaderAccept: 'text/plain' as '*/*',
      }),
    );
  }
}
